import { makeStyles, tokens } from '@fluentui/react-components';
import { fontScale } from '@/theme';

export const useRoomFilterPanelStyles = makeStyles({
  drawerBody: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalL,
    paddingTop: tokens.spacingVerticalM,
    paddingBottom: tokens.spacingVerticalM,
    overflowY: 'auto',
    flex: 1,
  },
  fieldGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalS,
  },
  footer: {
    display: 'flex',
    flexDirection: 'row',
    gap: tokens.spacingHorizontalS,
    paddingTop: tokens.spacingVerticalM,
    paddingBottom: tokens.spacingVerticalM,
    borderTopWidth: '1px',
    borderTopStyle: 'solid',
    borderTopColor: tokens.colorNeutralStroke1,
  },
  clearSelectionButton: {
    cursor: 'pointer',
    fontSize: fontScale.caption,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorBrandForeground1,
    paddingTop: tokens.spacingVerticalXS,
    paddingBottom: tokens.spacingVerticalXS,
    paddingLeft: tokens.spacingHorizontalS,
  },
  comboboxListbox: {
    maxHeight: '21.75rem !important' as unknown as string,
    paddingBottom: tokens.spacingVerticalXS,
  },
});
